import { DocumentTree } from "./document-tree.objects";



export class DocumentTreeLoader {

    documentTree: DocumentTree;

    constructor(nodes: any) {
        $(() => {

            console.log(nodes);

            this.documentTree = new DocumentTree(nodes);
        });
    }
}